import { AnyAction, createReducer } from '@reduxjs/toolkit';
import {
	requestLandingPageAccess,
	requestLandingPageAccessResolved,
	requestLandingPageAccessRejected,
} from '../actions/landingPageAccess.actions';

import { STATUS_ENUM } from '../types/reducers.types';
import { LandingPageAccessState } from '../types/userTeamAccess.types';

export const initialAccessState: LandingPageAccessState = {
	status: STATUS_ENUM.IDLE,
	isTeamAdmin: false,
	isHubAdmin: false,
	adminHubs: [],
	eligibleTeams: [],
};

export interface LandingPageAccessReducer {
	[x: string]: (
		state: LandingPageAccessState,
		action: AnyAction,
	) => LandingPageAccessState | undefined;
}

const reducer: LandingPageAccessReducer = {
	[requestLandingPageAccess.toString()]: state => ({
		...state,
		status: STATUS_ENUM.PENDING,
	}),
	[requestLandingPageAccessResolved.toString()]: (state, action) => ({
		...state,
		...action.payload,
		status: STATUS_ENUM.SUCCESS,
	}),
	[requestLandingPageAccessRejected.toString()]: state => ({
		...state,
		...initialAccessState,
		status: STATUS_ENUM.ERROR,
	}),
};

export default createReducer(initialAccessState, reducer);
